import { render } from "./DeclaracoesDocumentosList.vue?vue&type=template&id=411d779f&scoped=true"
import script from "./DeclaracoesDocumentosList.vue?vue&type=script&lang=js"
export * from "./DeclaracoesDocumentosList.vue?vue&type=script&lang=js"

import "./DeclaracoesDocumentosList.vue?vue&type=style&index=0&id=411d779f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411d779f"]])

export default __exports__